export const RECALL_EVENT_COPY = {
	title: {
		add: 'Add recall history event',
		edit: 'Edit recall history event',
	},
	submit: {
		add: 'Save',
		edit: 'Save',
	},
	description:
		'Capture the basics so templates reflect your actual recall and withdrawal experience.',
	fields: {
		typeLabel: 'What kind of event was it?',
		yearLabel: 'Which year did it occur?',
		productLabel: 'Which products or SKUs were involved?',
		outcomeLabel: 'How did the event conclude?',
	},
	actions: {
		addTrigger: 'Add event',
		removeConfirmTitle: 'Remove this recall event?',
		removeConfirmDescription:
			'This recall event will be removed from the history list.',
	},
	errors: {
		productRequired: 'Name the product, SKU family, or scope.',
		yearInvalid: 'Enter a 4-digit year.',
	},
} as const
